const trendingTopics = [
  "Terapia",
  "Transição Hormonal",
  "Especialistas",
  "Psicologia",
  "Hormônios",
  "Mastectomia",
];

const articles = [
  {
    id:1,
    autor: "Luciana Pangaio",
    date: "28/11/2021",
    title: "Desmistificando a depressão",
    text: `A depressão é uma das doenças mentais mais comentadas na atualidade, sendo representada amplamente na mídia, por novelas, filmes, séries, e até mesmo debates com especialistas durante o horário nobre da TV aberta.

        Mas o que é realmente a depressão?A depressão é um dos transtornos de humor mais comuns na atualidade, atingindo cerca de X% da população brasileira segundo os dados da pesquisa realizada em 2020.
        
        Dentro da comunidade LGBTQI+, esse número chega a triplicar. Devido aos preconceitos e pressões da sociedade, jovens da comunidade Queer tem mais chances de desenvolver quadrões de depressão, ansiedade, e ter pensamentos suicidas.`,
  },
  {
    id:2,
    autor: "Luciana Pangaio",
    date: "28/11/2021",
    title: "Nome social: Um direito de todes",
    text: `A depressão é uma das doenças mentais mais comentadas na atualidade, sendo representada amplamente na mídia, por novelas, filmes, séries, e até mesmo debates com especialistas durante o horário nobre da TV aberta.

        Mas o que é realmente a depressão?A depressão é um dos transtornos de humor mais comuns na atualidade, atingindo cerca de X% da população brasileira segundo os dados da pesquisa realizada em 2020.
        
        Dentro da comunidade LGBTQI+, esse número chega a triplicar. Devido aos preconceitos e pressões da sociedade, jovens da comunidade Queer tem mais chances de desenvolver quadrões de depressão, ansiedade, e ter pensamentos suicidas.`,
  },
  {
    id:3,
    autor: "Luciana Pangaio",
    date: "28/11/2021",
    title: "Quero iniciar minha transição, e agora?",
    text: `A depressão é uma das doenças mentais mais comentadas na atualidade, sendo representada amplamente na mídia, por novelas, filmes, séries, e até mesmo debates com especialistas durante o horário nobre da TV aberta.

        Mas o que é realmente a depressão?A depressão é um dos transtornos de humor mais comuns na atualidade, atingindo cerca de X% da população brasileira segundo os dados da pesquisa realizada em 2020.
        
        Dentro da comunidade LGBTQI+, esse número chega a triplicar. Devido aos preconceitos e pressões da sociedade, jovens da comunidade Queer tem mais chances de desenvolver quadrões de depressão, ansiedade, e ter pensamentos suicidas.`,
  },
  {
    id:4,
    autor: "Luciana Pangaio",
    date: "28/11/2021",
    title: "Disforia: Como lidar?",
    text: `A depressão é uma das doenças mentais mais comentadas na atualidade, sendo representada amplamente na mídia, por novelas, filmes, séries, e até mesmo debates com especialistas durante o horário nobre da TV aberta.

        Mas o que é realmente a depressão?A depressão é um dos transtornos de humor mais comuns na atualidade, atingindo cerca de X% da população brasileira segundo os dados da pesquisa realizada em 2020.
        
        Dentro da comunidade LGBTQI+, esse número chega a triplicar. Devido aos preconceitos e pressões da sociedade, jovens da comunidade Queer tem mais chances de desenvolver quadrões de depressão, ansiedade, e ter pensamentos suicidas.`,
  },
];

export { trendingTopics, articles };
